const LOCALE = 'en-US';
const CURRENCY = 'USD';

function formatMoney(money: any) {
  const num = parseFloat(money);
  if (isNaN(num)) return undefined;

  return `${num.toFixed(2)}`;
}

function applyShelterCurrency(money?: string | number, isNegative: boolean = false): string {
  if (money === undefined || money === null) {
    throw new Error(`Undefined money at applyShelterCurrency(): ${money}`);
  }

  const num = Number(money);
  if (isNaN(num)) {
    throw new Error(`Invalid money value: ${money}`);
  }

  const absFormatted = new Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency: CURRENCY,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(num));

  return num < 0 || isNegative ? absFormatted.replace(/^(\D+)/, '$1(') + ')' : absFormatted;
}

function getShelterCurrency(): string {
  return (
    new Intl.NumberFormat(LOCALE, {
      style: 'currency',
      currency: CURRENCY,
    })
      .formatToParts(0)
      .find((part) => part.type === 'currency')?.value ?? ''
  );
}

export { applyShelterCurrency, formatMoney, getShelterCurrency };
